import { Calendar } from '@demind-inc/core';

const READ_ONLY_CALENDAR_SCOPES = new Set(['freeBusyReader', 'reader']);

export const hasReadOnlyCalendarScope = (calendar?: Pick<Calendar, 'scope'> | null): boolean =>
  READ_ONLY_CALENDAR_SCOPES.has(calendar?.scope ?? '');
